<div class="breadcrumb-container" *ngIf="breadcrumbs && breadcrumbs.length">
  <ul class="breadcrumb-desktop">
    <ng-container *ngFor="let breadcrumb of breadcrumbs">
      <li class="breadcrumb-item" *ngIf="breadcrumb.text">
        <a
          *ngIf="breadcrumb.routerLink"
          [routerLink]="breadcrumb.routerLink"
          [queryParams]="breadcrumb.queryParams ? breadcrumb.queryParams : {}"
          class="breadcrumb-link off"
        >
          {{ breadcrumb.text }}
        </a>
        <a
          *ngIf="!breadcrumb.routerLink"
          class="breadcrumb-link disabled"
          [class.breadcrumb-status]="breadcrumb.color"
          [style.color]="breadcrumb.color ? breadcrumb.color : ''"
        >
          {{ breadcrumb.text }}
        </a>
      </li>
    </ng-container>
  </ul>
</div>
